import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PatientConfirmDialogComponent, ConfirmDialogModel } from 'src/app/ChildControls/patient-confirm-dialog/patient-confirm-dialog.component';
import { MatTableDataSource } from '@angular/material';
import { InsuranceService } from 'src/app/Services/AdminConfigurations/insurance.service';
import { ReferenceDataService } from 'src/app/Services/AdminConfigurations/reference-data.service';
import { InsuranceCarriers } from 'src/app/models/InsuranceCarriers';
import { IAddress } from 'src/app/models/IAddress';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
// formatting helper was previously imported from src/app/utils/formatters
// The helper is implemented locally in this component as `formatClaimTypeConfig`.

@Component({
  selector: 'app-insurance-carriers-lookup',
  templateUrl: './insurance-carriers-lookup.component.html',
  styleUrls: ['./insurance-carriers-lookup.component.css']
})
export class InsuranceCarriersLookupComponent implements OnInit {
  displayedColumns: string[] = ['insuranceName', 'IndustryPayerID', 'ClaimsID', 'EligibilityID', 'ClaimStatusID', 'Attachment', 'Enrollment', 'action'];

  allCarriers: any[] = [];


  filteredCarriers: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  searchTerm: string = '';

  existingCarriers: InsuranceCarriers[] = [];
  private existingCarriersMap = new Map<string, InsuranceCarriers>();

  constructor(
    public dialogRef: MatDialogRef<InsuranceCarriersLookupComponent>,
    //@Inject(MAT_DIALOG_DATA) public data: any,
    private referenceDataService: ReferenceDataService,
    private insurance: InsuranceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.loadExistingCarriers();
    this.loadReferenceCarriers();
  }

  loadExistingCarriers() {

    this.insurance.getallInsurences().subscribe(data => {
      if (data as InsuranceCarriers[]) {
        this.existingCarriers = data as InsuranceCarriers[];
        
        this.buildExistingCarriersMap();
        this.stampCarrierFlags();
      }
    });
    // if (this.data && this.data.existingCarriers) {
    //   this.data.existingCarriers.forEach((carrier: InsuranceCarriers) => {
    //     if (carrier.PayerMapId) {
    //       this.existingPayerMapIds.add(carrier.PayerMapId);
    //     }
    //   });
    
  }

  loadReferenceCarriers() {
    this.spinner.show();
    this.referenceDataService.getInsuranceCarriers().subscribe(
      (data) => {
        if (data) {
          const raw = Array.isArray(data) ? data : (data as any).data || (data as any).result || [];
          const carriers = raw.map(c => this.normalizeCarrier(c));
          this.allCarriers = carriers;
          this.filteredCarriers = [...this.allCarriers];
          this.stampCarrierFlags();
          this.dataSource.data = this.filteredCarriers;
          this.cdr.detectChanges();

        }
        this.spinner.hide();
      },
      (err) => {
        console.error(err);
        this.spinner.hide();
      }
    );
  }

  private normalizeCarrier(c: any): any {
    const rawConfig = c.claimTypeConfig || c.ClaimTypeConfig || '';
    const eligibilityEnrollment = c.eligibilityEnrollmentRequired || c.EligibilityEnrollmentRequired || false;
    const claimsEnrollment = c.claimsEnrollmentRequired || c.ClaimsEnrollmentRequired || false;
    const claimsStatusEnrollment = c.claimStatusEnrollmentRequired || c.ClaimStatusEnrollmentRequired || false;
    const eraEnrollment = c.eraEnrollmentRequired || c.EraEnrollmentRequired || c.ERAEnrollmentRequired || false;
    // Attachment isn't returned by referencedata/insurancecarriers yet - update this mapping
    // once the API exposes the field; defaults to false (No) until then.
    const attachmentEnrollment = c.attachmentEnrollmentRequired || c.AttachmentEnrollmentRequired || false;
    return {
      insuranceCarrierId: 0,
      payerMasterId: c.payerMasterId || c.PayerMasterId,
      insuranceName: c.payerName || c.PayerName || c.insuranceName,
      // PayerId is sourced from mD4FrontPayerID (the reference API's own GUID identifier),
      // not the legacy payerId business code
      PayerId: c.mD4FrontPayerID || c.MD4FrontPayerID || c.mD4FrontPayerId,
      // Industry Payer ID - the clearinghouse/EDI business Payer ID, shown to users as "Payer ID"
      IndustryPayerID: c.industryPayerID || c.IndustryPayerID || c.industryPayerId,
      ChcPayerId: null,
      ClaimsID: c.claimsID || c.ClaimsID,
      claimType: c.claimType || c.ClaimType,
      claimTypeConfig: rawConfig,
      // new pre-formatted value for display to avoid calling formatter from template
      claimTypeConfigFormatted: this.formatClaimTypeConfig(rawConfig),
      EligibilityID: c.eligibilityID || c.EligibilityID || c.eligibilityId,
      ClaimStatusID: c.claimStatusID || c.ClaimStatusID || c.claimStatusId,
      ClaimStatus: c.claimStatus || c.ClaimStatus,
      Claims: c.claims || c.Claims,
      Remit: c.remit || c.Remit,
      Eligibility: c.eligibility || c.Eligibility,
      EligibilityEnrollment: eligibilityEnrollment,
      ClaimsEnrollment: claimsEnrollment,
      ClaimsStatusEnrollment: claimsStatusEnrollment,
      ERAEnrollment: eraEnrollment,
      AttachmentEnrollment: attachmentEnrollment,
      // Single Yes/No shown in the grid - Yes if any individual enrollment type is required
      HasEnrollment: !!(eligibilityEnrollment || claimsEnrollment || claimsStatusEnrollment || eraEnrollment),
      isActive: true,
       IndustryPayerId: c.industryPayerId || c.IndustryPayerId,
       Attachments: c.attachments || c.attachments,
       AttachmentType: c.attachmentType || c.AttachmentType,
       OtherClaimsID: c.otherClaimsID || c.otherClaimsId,
       OtherIndustryPayerId : c.otherIndustryPayerId ||c.otherIndustryPayerID
    };
  }

  applySearch() {
    const term = this.searchTerm.trim().toLowerCase();
    if (term) {
      this.filteredCarriers = this.allCarriers.filter(c =>
        (c.insuranceName && c.insuranceName.toLowerCase().includes(term)) ||
        (c.IndustryPayerID && c.IndustryPayerID.toLowerCase().includes(term))
        // (c.claimType && c.claimType.toLowerCase().includes(term)) ||
        // (c.insuranceCode && c.insuranceCode.toLowerCase().includes(term))
      );
    } else {
      this.filteredCarriers = [...this.allCarriers];
    }
    this.dataSource.data = this.filteredCarriers;
  }

  clearSearch() {
    this.searchTerm = '';
    this.applySearch();
  }

  private getCarrierKey(name: string, payerId: string): string {
    return `${(name || '').toLowerCase()}|${payerId}`;
  }

  private buildExistingCarriersMap(): void {
    this.existingCarriersMap.clear();
    this.existingCarriers.forEach(e => {
      const key = this.getCarrierKey(e.insuranceName, e.PayerId);
      this.existingCarriersMap.set(key, e);
    });
  }

  private stampCarrierFlags(): void {
    this.allCarriers.forEach(c => {
      const key = this.getCarrierKey(c.insuranceName, c.PayerId);
      const existing = this.existingCarriersMap.get(key);
      c.isExisting = !!existing;
      c.isModifyEnabled = existing ? existing.PayerId !== c.PayerId : false;
    });
  }

  formatClaimTypeConfig(value: string): string {
    if (!value) return '';
    const v = value.toUpperCase();
    if (v === 'CMS1500') return 'CMS-1500';
    if (v === 'UB04' || v === 'UB-04') return 'UB-04';
    // fallback: insert dash before last two digits if pattern matches (e.g. ABC1234 -> ABC-1234)
    const m = v.match(/^([A-Z]+)(\d+)$/);
    if (m) return `${m[1]}-${m[2]}`;
    return value;
  }

  editCarrier(carrier: any) {
    const dialogData = new ConfirmDialogModel('Confirm Modify', `Are you sure you want to modify "${carrier.insuranceName}"?`);
    const confirmRef = this.dialog.open(PatientConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    confirmRef.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close({ refreshRequired: false, editCarrier: carrier });
      }
    });
  }

  addCarrier(carrier: any) {
    const dialogData = new ConfirmDialogModel('Confirm Add', `Are you sure you want to add "${carrier.insuranceName}"?`);
    const confirmRef = this.dialog.open(PatientConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    confirmRef.afterClosed().subscribe(result => {
      if (!result) return;
      this.spinner.show();
    const insuranceDetails = new InsuranceCarriers();
    insuranceDetails.insuranceName = carrier.insuranceName;
    insuranceDetails.PayerId = carrier.PayerId;
    insuranceDetails.ChcPayerId = carrier.ChcPayerId;

    insuranceDetails.claimType = carrier.claimType;
    if (carrier.claimType && carrier.claimType.toUpperCase() === 'INSTITUTIONAL') {
      insuranceDetails.institutionPayer = carrier.ClaimsID;
      insuranceDetails.professionPayer = carrier.OtherClaimsID;
    } else if (carrier.claimType && carrier.claimType.toUpperCase() === 'PROFESSIONAL') {
      insuranceDetails.professionPayer = carrier.ClaimsID;
      insuranceDetails.institutionPayer = carrier.OtherClaimsID;
    }
    insuranceDetails.payerClass = '0';//carrier.payerClass;
    insuranceDetails.claimTypeConfig = carrier.claimTypeConfig;
    insuranceDetails.isActive = carrier.isActive;
    insuranceDetails.IsCustomPayer = false;
    insuranceDetails.createdBy = encodeURIComponent(sessionStorage.getItem('userId')).toString();
    insuranceDetails.planIds = [];

    insuranceDetails.Eligibility = carrier.Eligibility;
    insuranceDetails.Claims = carrier.Claims;
    insuranceDetails.Remit = carrier.Remit;
    insuranceDetails.ClaimStatus = carrier.ClaimStatus;

    insuranceDetails.EligibilityID = carrier.EligibilityID;
    insuranceDetails.ClaimStatusID = carrier.ClaimStatusID;
    insuranceDetails.EligibilityEnrollment = carrier.EligibilityEnrollment;
    insuranceDetails.ClaimsEnrollment = carrier.ClaimsEnrollment;
    insuranceDetails.ClaimsStatusEnrollment = carrier.ClaimsStatusEnrollment;
    insuranceDetails.ERAEnrollment = carrier.ERAEnrollment;
    insuranceDetails.IndustryPayerID=carrier.IndustryPayerId;
    insuranceDetails.Attachments=carrier.Attachments;
    insuranceDetails.AttachmentType=carrier.AttachmentType;
    
    const addressDetails: IAddress = {
      address1: '',
      address2: '',
      address3: '',
      addressId: null,
      state: '',
      stateCode: '',
      city: '',
      postalCode: '',
      postalExCode: '',
      cellPhone: null,
      workPhone: null,
      homePhone: null,
      fax: null,
      emailId: null,
      createdBy: encodeURIComponent(sessionStorage.getItem('userId')).toString(),
      createdOn: null,
      secondaryaddress1: '',
      secondaryaddress2: '',
      secondaryaddress3: '',
      secondarystate: '',
      secondarystateCode: '',
      secondarycity: '',
      secondarypostalCode: '',
      secondarypostalExCode: '',
      MailingAddress: '',
      phonenumber4: '',
      phonenumber5: ''
    };
    insuranceDetails.addressDetails = addressDetails;

    this.insurance.saveInsurencesDetails(insuranceDetails).subscribe(
      (result) => {
        this.existingCarriers.push(insuranceDetails);
        const key = this.getCarrierKey(insuranceDetails.insuranceName, insuranceDetails.PayerId);
        this.existingCarriersMap.set(key, insuranceDetails);
        carrier.isExisting = true;
        carrier.isModifyEnabled = false;
        this.toastr.success(result);
        this.spinner.hide();
        this.cdr.detectChanges();
      },
      (err) => {
        this.toastr.error('Failed to add carrier');
        this.spinner.hide();
      }
    );
    });
  }

  close() {
    this.dialogRef.close({ refreshRequired: true });
  }
}
